module.exports = __webpack_public_path__ + "static/media/Town80Text-Light.1be4c60f.otf";